import React, { useContext, useState } from 'react'
import { loginAuth, signupAuth } from '../../services/API';
import { UserContext } from '../../Context/ContextProvider';

const signUpInitialValues={
  firstName:'',
  lastName:'',
  userName:'',
  gender:'',
  email:'',
  phone:'',
  password:'',
}
const logInInitialValues={
  userName:'',
  password:'',
}
const LoginDialogue = ({closeLoginDialogue}) => {
  const [loginOrSignup, setLoginOrSignup] = useState('login');
  const [password, setPassword] = useState('');
  const [signup, setSignUp] = useState(signUpInitialValues);
  const [login, setLogin] = useState(logInInitialValues);
  

  const [passwordVisible, setPasswordVisible] = useState(false);

  const {user,setUser,gender,setGender}=useContext(UserContext)
  
  const togglePasswordVisibility = () => {
    passwordVisible ? setPasswordVisible(false) : setPasswordVisible(true);
  };
  const handleSignupInputChange=(e)=>{
    setSignUp({...signup,[e.target.name]:e.target.value})
  }
  const handleLoginInputChange=(e)=>{
    setLogin({...login,[e.target.name]:e.target.value})
  }

  const handleSignup=async(e)=>{
    e.preventDefault();
    const res=await signupAuth(signup);
    if(!res){
      return;
    }
    closeLoginDialogue();
  }
  const handleLogin=async(e)=>{
    e.preventDefault();
    const res=await loginAuth(login);
    const data=res.data;
    if(!res){
      return;
    }
    else{
      console.log(data);
      setUser(data.data.userName);
      setGender(data.data.gender);
      // console.log(user);
      // console.log(gender);
      closeLoginDialogue();
    }
  }

  return (
    <>
      <div className='flex rounded-lg space-x-[30px] flex-col md:flex-row'>
        <div className='w-[100%] flex justify-center py-[12px] md:w-[60%]'>
            {
              loginOrSignup==='login'?
                <div className='w-[100%]'>
                <form action="" className='flex flex-col space-y-5'>

                    {/* <input type="text" placeholder='Username' className='outline-none border-b-2 border-blue-950 px-2' onChange={(e)=>{handleLoginInputChange(e)}} name='userName'/> */}
                    {/* <div className='flex'> */}
                        {/* <input placeholder='Password' type='password' className='outline-none border-b-2 border-blue-950 px-2'  onChange={(e)=>{handleLoginInputChange(e)}} name='password'/> */}
                        
                        {/* {password === "" ? (
                        <div></div>
                        ) : passwordVisible ? (
                        <img
                            src={require("../../Images/eye-hidden.png")}
                            alt=""
                            onClick={togglePasswordVisibility}
                            className="h-[26px] mb-[20px] mx-[-40px]"
                        />
                        ) : (
                        <img
                            src={require("../../Images/eye_gray.png")}
                            alt=""
                            className="h-[30px] mb-[20px] mx-[-40px]"
                            onClick={togglePasswordVisibility}
                        />
                        )} */}
                    {/* </div> */}
                    <div className="relative z-0">
                        <input type="text" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer " placeholder=" " name='userName'
                        onChange={(e)=>{handleLoginInputChange(e)}}/>
                        <label htmlhtmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                        >Username</label>
                    </div>
                    <div className="relative z-0">
                        <input type="password" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer" placeholder=" " name='password'
                        onChange={(e)=>{handleLoginInputChange(e)}}/>
                        <label htmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                        >Password</label>
                    </div>
                    <button type='submit' className='bg-pink-700 py-[8px] rounded-lg shadow-2xl text-white hover:bg-pink-600' onClick={handleLogin}>Log In</button>

                </form>
            <div className='text-[12px] mt-[20px] flex justify-center'>
                <span className='text-slate-500 '>Don't have an account?</span>
                <span className='text-blue-950 font-bold cursor-pointer hover:text-blue-900 hover:underline' 
                onClick={()=>{setLoginOrSignup('signup')}}
                >Sign Up</span>
            </div>
                </div>
            :
            <div className='w-[100%]'>
            <form action="" className='flex flex-col space-y-5'>
                    {/* <input type="text" placeholder='First Name' onChange={(e)=>{handleSignupInputChange(e)}} name='firstName' className='outline-none border-b-2 border-blue-950 px-2'/>
                    <input type="text" placeholder='Last Name' onChange={(e)=>{handleSignupInputChange(e)}} name='lastName' className='outline-none border-b-2 border-blue-950 px-2'/>
                    <input type="text" placeholder='User Name' onChange={(e)=>{handleSignupInputChange(e)}} name='userName' className='outline-none border-b-2 border-blue-950 px-2'/>
                    <input type="email" placeholder='Email Address' onChange={(e)=>{handleSignupInputChange(e)}} name='email' className='outline-none border-b-2 border-blue-950 px-2'/>
                    <input type="number" placeholder='Mobile Number' onChange={(e)=>{handleSignupInputChange(e)}} name='phone' className='outline-none border-b-2 border-blue-950 px-2'/>
                    <input type="password" placeholder='Password' onChange={(e)=>{handleSignupInputChange(e)}} name='password' className='outline-none border-b-2 border-blue-950 px-2' /> */}

                    <div className="relative z-0">
                        <input type="text" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer" placeholder=" "  name='firstName'
                        onChange={(e)=>{handleSignupInputChange(e)}}/>
                        <label htmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                       >First Name</label>
                    </div>
                    <div className="relative z-0">
                        <input type="text" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer" placeholder=" " name='lastName'
                        onChange={(e)=>{handleSignupInputChange(e)}}/>
                        <label htmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                        >Last Name</label>
                    </div>
                    <div className="relative z-0">
                        <input type="text" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer" placeholder=" " name='userName'
                        onChange={(e)=>{handleSignupInputChange(e)}}/>
                        <label htmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                        >User Name</label>
                    </div>
                    <div className="relative z-0">
                        <input type="text" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer" placeholder=" " name='gender'
                        onChange={(e)=>{handleSignupInputChange(e)}}/>
                        <label htmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                        >Gender</label>
                    </div>
                    <div className="relative z-0">
                        <input type="text" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer" placeholder=" " name='email'
                        onChange={(e)=>{handleSignupInputChange(e)}}/>
                        <label htmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                        >E-mail Address</label>
                    </div>
                    <div className="relative z-0">
                        <input type="text" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer" placeholder=" " name='phone'
                        onChange={(e)=>{handleSignupInputChange(e)}}/>
                        <label htmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                        >Phone Number</label>
                    </div>
                    <div className="relative z-0">
                        <input type="password" id="floating_standard" className="block py-1.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-purple-500 focus:outline-none focus:ring-0 focus:border-purple-600 peer" placeholder=" " name='password'
                        onChange={(e)=>{handleSignupInputChange(e)}}/>
                        <label htmlFor="floating_standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-purple-600 peer-focus:dark:text-purple-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6" 
                        >Password</label>
                    </div>

                    <button type='submit' className='bg-pink-700 py-[8px] rounded-lg shadow-2xl text-white hover:bg-pink-600' onClick={handleSignup}>Sign Up</button>
            </form>
            <div className='text-[12px] mt-[20px] flex justify-center'>
                <span className='text-slate-500'>Already have an account?</span>
                <span className='text-blue-950 font-bold cursor-pointer hover:text-blue-900 hover:underline' 
                onClick={()=>{setLoginOrSignup('login')}}
                >Login</span>
            </div>
            </div>
            }
            
            
        </div>
        <div className='flex-col justify-center w-[100%] mx-[20px] my-[auto] md:w-[40%] bg-slate-100 '>
            <img src={require('../../Images/shopping-2.jpg')} alt="" className='w-[300px] h-[150px] mx-auto'/>
            {
              loginOrSignup==='login'?
              <div className='text-center'>Login to access your account!</div>:
              <div className='text-center'>Signup to unlock more features..</div>
            }
        </div>
      </div>
    </>
  )
}

export default LoginDialogue
